const MOBILE_FIRST_SEGMENTS = new Set(["availability", "engage", "events", "material", "mobile", "verify"]);

const TOP_BAR_ONLY_ROUTES = new Set(["/my-commissions", "/my-proposal", "/notifications"]);

const isMobileFirstPath = (pathname: string): boolean => MOBILE_FIRST_SEGMENTS.has(pathname.split("/")[1] ?? "");

export const isTopBarOnlyRoute = (pathname: string): boolean => TOP_BAR_ONLY_ROUTES.has(pathname);

export default isMobileFirstPath;
